<template>
  <ChecklistTableTaskCellWrapper :clickable="isCurrentUserPm"
                                 data-locator="validators-area"
                                 @click="onEditValidators"
  >
    <div class="ChecklistTableTaskValidators">
      <template v-if="validatorsList.length > 0">
        <div class="d-flex flex-column">
          <template v-for="item in validatorsList" :key="item.id">
            <span>{{ item.name || item.fullName }}</span>
          </template>
        </div>
      </template>
      <template v-else>
        <ChecklistTableTaskEmptyCell />
      </template>
    </div>
  </ChecklistTableTaskCellWrapper>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import ChecklistTableTaskCellWrapper from '@/project/checklist/table/ChecklistTableTaskCellWrapper.vue'
import ChecklistTableTaskEmptyCell from '@/project/checklist/table/ChecklistTableTaskEmptyCell.vue'
import { SET_SHARE_TASKS_DIALOG } from '@/store/modules/checklist/mutation_types'

export default {
  name: 'ChecklistTableTaskValidators',
  components: {
    ChecklistTableTaskCellWrapper,
    ChecklistTableTaskEmptyCell,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['isCurrentUserPm']),
    validatorsList () {
      const validatorsUsers = this.item.rights?.validators?.users || []
      const validatorsGroups = this.item.rights?.validators?.groups || []

      return [...validatorsUsers, ...validatorsGroups]
    },
  },
  methods: {
    ...mapMutations('checklist', [SET_SHARE_TASKS_DIALOG]),
    async onEditValidators () {
      if(!this.isCurrentUserPm) return

      this.SET_SHARE_TASKS_DIALOG({
        isOpen: true,
        tasksToShare: [this.item],
      })
    },
  },
}
</script>

<style scoped lang="scss">
.ChecklistTableTaskValidators {
  display: flex;
  flex-direction: column;
}
</style>
